const redirect = (e, path, _blank) => {
  if (_blank) {
    let routeUrl = e.$router.resolve({
      path: path
    });
    window.open(routeUrl.href, '_blank');
  } else {
    e.$router.push({ path: path })
  }

}

// 动态加载js
const loadScript = (url, callback) => {
  if (typeof document !== "undefined") {
    var script = document.createElement("script");
  }
  script.type = "text/javascript";
  if (typeof callback !== "undefined") {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
  }
  script.src = url;
  if (typeof document !== "undefined") {
    document.head.appendChild(script);
  }
}

const loadStatistics = function () {
  if (typeof document !== "undefined") {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://hm.baidu.com/hm.js?ab1739172a997fa72f0fb9792ddda29e";
    document.body.append(script);
  }
}

// 设置标题
const setTitle = (title) => {
  let userinfo = localStorage.getItem("userInfo");
  userinfo = userinfo ? JSON.parse(userinfo) : null
  document.title = (title ? title +'-' : '') + '高校思想政治理论课实践教学平台' + (userinfo ? '-' + userinfo.school_name : '')
}
/**
 * 构造树型结构数据
 * @param {*} source 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
const transTreeData = (source, id, parentId, children, rootId) => {
  id = id || 'id'
  parentId = parentId || 'parentId'
  children = children || 'children'
  rootId = rootId || 0
  const cloneData = JSON.parse(JSON.stringify(source))// 对源数据深度克隆
  return cloneData.filter(father => {
    const branchArr = cloneData.filter(child => father[id] == child[parentId])// 返回每一项的子级数组
    branchArr.length > 0 ? father[children] = branchArr : delete father[children]// 如果存在子级，则给父级添加一个children属性，并赋值
    return father[parentId] == rootId // 返回第一层
  })
}

// 判断是否是手机端访问
const isMobile = () => {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}

// 判断是否是谷歌浏览器
const bowerUserAgent = () => {
  var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
  let isChrome = false
  if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") == -1) {
    isChrome = true
  } else {
    isChrome = false
  }
  return isChrome
}

// 获取浏览器地址栏中的学校code
const getUrlSchoolCode = (url) => {

  let code = ''
  if (url) {
    let arr = url.split("/");
    code = arr[1]
  }
  return code
}
// 数字转汉字 1 => 一
const changeNumToHan = (num) => {
  var arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  var arr2 = ["", "十", "百", "千", "万", "十", "百", "千", "亿", "十", "百", "千", "万", "十", "百", "千", "亿"]; //可继续追加更高位转换值
  if (!num || isNaN(num)) {
    return "零";
  }
  var english = num.toString().split("");
  var result = "";
  for (var i = 0; i < english.length; i++) {
    var des_i = english.length - 1 - i; //倒序排列设值
    result = arr2[i] + result;
    var arr1_index = english[des_i];
    result = arr1[arr1_index] + result;
  }
  //将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零([千百十])/g, "零").replace(/十零/g, "十");
  //合并中间多个零为一个零
  result = result.replace(/零+/g, "零");
  //将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/零亿/g, "亿").replace(/零万/g, "万");
  //将【亿万】换成【亿】
  result = result.replace(/亿万/g, "亿");
  //移除末尾的零
  result = result.replace(/零+$/, "");
  //将【零一十】换成【零十】
  //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
  //将【一十】换成【十】
  result = result.replace(/^一十/g, "十");
  return result;
}

// 随机密码
const randomPassword = () => {
  let arr = [1, 2, 3] // 保证九位随机码包含数字+大写字母+小写字母
  let code = ''
  function getRandom (min, max) {
    return Math.round(Math.random() * (max - min) + min)
  }
  function randomsort (a, b) {
    a, b
    return Math.random() > 0.5 ? -1 : 1
    // 用Math.random()函数生成0~1之间的随机数与0.5比较，返回-1或1
  }
  for (let i = 0; i < 6; i++) {
    arr.push(getRandom(1, 3)) // 补成六位
  }
  arr.sort(randomsort) // 打乱数组
  for (let i = 0; i < 9; i++) {

    let type = arr[i]
    switch (type) {
      case 1:
        code += String.fromCharCode(getRandom(48, 57)) // 数字
        break
      case 2:
        code += String.fromCharCode(getRandom(65, 90)) // 大写字母
        break
      case 3:
        code += String.fromCharCode(getRandom(97, 122)) // 小写字母
        break
    }
  }
  return code
}


// 需要校验登录状态的路由  "/szztk/ylzl", "/szztk/yzzsjzj",
const whiteList = ["/szysk/details", "/szzyk/details", "/szztk/details", "/szztk/ssjt", "/szztk/xxys", "/szztk/xfrw/sdkm", "/szztk/xfrw/sdkm/details/1", "/szztk/detail"];
// 判断路由是否包含有whiteList
const pathRouteName = (path) => {
  var isName = false
  for (var i = 0; i < whiteList.length; i++) {
    if (path.indexOf(whiteList[i]) > -1) {
      isName = true
      break;
    }
  }
  return isName
}

export default {
  redirect,
  loadScript,
  setTitle,
  loadStatistics,
  transTreeData,
  isMobile,
  whiteList,
  pathRouteName,
  bowerUserAgent,
  getUrlSchoolCode,
  changeNumToHan,
  randomPassword
}
